import config from 'configs/app';

export function buildWebsiteJsonLd(baseUrl = config.app.baseUrl) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: `${ config.chain.name } explorer`,
    url: baseUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${ baseUrl }/search-results?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}
